
export const TYPES = {
    VR: 'vr',
    BUILDING: 'building',
    VIDEO: 'video',
    SUNLIGHT: 'sunlight',
    VOICE: 'voice'
}
export const TYPES_VALUE = {
    'vr': 'VR视频',
    'building': '总平图',
    'video': '视频',
    'sunlight': '日照',
    'voice': '语音'
}
export const TABS = [
    {
        key: TYPES.VR,
        name: 'VR看房',
    },
    {
        key: TYPES.BUILDING,
        name: '楼盘总平',
    },
    {
        key: TYPES.VIDEO,
        name: '视频看房',
    },
    {
        key: TYPES.SUNLIGHT,
        name: '日照看房'
    }, 
    {
        key: TYPES.VOICE,
        name: '语音看房'
    }
]
export const SHARE_INFO = {
    [TYPES.VR]: 'VR看房，宅家也能看新房，点击查看~',
    [TYPES.BUILDING]: '楼盘总平，更清楚更直观，点击查看~',
    [TYPES.VIDEO]: '视频看房，了解楼盘更多信息，点击查看~',
    [TYPES.SUNLIGHT]: '日照看房，不同时段日照情况，点击查看~',
    [TYPES.VOICE]: '语音讲房，听一听这个户型怎么样，点击查看~'
}

export const FILTER_KEYS = [
    'decoration',
    'zone_ids',
    'area',
    'total_price',
    'price',
    'layout',
    'metro',
    'status',
    'zone_section_ids'
]